import axiosInstance from "@/plugins/HTTP";

class AuthService {
  async login(user) {
    try {
      const ipResponse = await fetch("https://api.ipify.org?format=json");
      const ipData = await ipResponse.json();
      const publicIp = ipData.ip;

      const response = await axiosInstance.post("/login", {
        username: user.username,
        password: user.password,
        client_public_ip: publicIp, // Add IP to payload
      });

      if (response.data.data.result) {
        localStorage.setItem("user", JSON.stringify(response.data.data.result));
      }

      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async register(user) {
    try {
      const ipResponse = await fetch("https://api.ipify.org?format=json");
      const ipData = await ipResponse.json();
      const publicIp = ipData.ip;

      const response = await axiosInstance.post("sign-up", {
        username: user.username,
        password: user.password,
        client_public_ip: publicIp,
        subscription_type:"free",
      });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

    async forgotOtpSend(user) {
    try {
      const response = await axiosInstance.post("forgot-password", {
        username: user.username,
      });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

    async ResetPassword(form) {
    try {
      const response = await axiosInstance.post("reset-password-validate", form);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }

    async verifyToken(form) {
    try {
      const response = await axiosInstance.post("verify-user", form);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default new AuthService();

